module.exports = __webpack_public_path__ + "img/Papua New Guinea.80672d97.gif";